module.exports = __webpack_public_path__ + "media/images/logo-rema-fecd5ea9a7cd3395f32c77a11c69bc6d.png";